import type { IExamSet } from "@/apis/exam_sets/types";
import type { IExamAssignmentMonitorResponse } from "./getExamAssignmentMonitor";
import type { SubjectType } from "@/apis/exam_progress/types";

// 기존 monitor API 타입들을 재사용
export type {
  IProgressListItem,
  IExamAssignmentMonitorResponse,
} from "./getExamAssignmentMonitor";

/**
 * Check if user has assigned subject
 */
export const hasAssignedSubject = (
  userId: string,
  subject: SubjectType,
  examAssignmentMonitor?: IExamAssignmentMonitorResponse | null
): boolean => {
  if (!examAssignmentMonitor?.progress_list) return false;

  const userProgress = examAssignmentMonitor.progress_list.find(
    (item) => item.progress.user_id === userId
  );

  if (!userProgress) return false;

  // Check if user has this subject assigned (not excluded)
  const assignedPaper = userProgress.progress.assigned_papers?.find(
    (paper) => paper.subject === subject
  );

  return !!assignedPaper;
};

/**
 * Check if subject is available in exam set
 */
export const isSubjectAvailableInExamSet = (
  subject: SubjectType,
  examSet?: IExamSet | null
): boolean => {
  if (!examSet?.items) return false;

  return examSet.items.some((item) => item.exam_paper?.subject === subject);
};

/**
 * Get all available subjects from exam set
 */
export const getAvailableSubjectsFromExamSet = (
  examSet?: IExamSet | null
): SubjectType[] => {
  if (!examSet?.items) return [];

  const subjects = examSet.items
    .map((item) => item.exam_paper?.subject)
    .filter((subject): subject is SubjectType => !!subject);

  // Remove duplicates
  return [...new Set(subjects)];
};
